import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define interfaces for the state
interface P2PAddPayload {
  coin: any | null;
  type: string;
  fiatCurrency: any | null;
  price: number | null;
  minLimit: number | null;
  maxLimit: number | null;
  paymentMethods: any[];
  paymentTimeLimit: number;
  amount: number | null;
  remarks: string | null;
}

interface P2POrderPayload {
  type?: string;
  offerId: string | null;
  totalAmountCoin: number | null;
  totalPaymentInFait: number | null;
  paymentMethods: any | null;
  paymentTimeLimitMinutes: number | null;
}

interface UserState {
  user: any | null;
  token: string | null;
  loggedIn: boolean;
  loading: boolean;
  firebaseToken: string | null;
  selectedCoin: any | null;
  selectedCurrency: any | null;
  p2pFormStep: number;
  activePair: any | null;
  totalPair: any | null;
  activeCoin: any;
  activeWithdrawCoin: any | null;
  p2pAddPayload: P2PAddPayload;
  P2PorderPayload: P2POrderPayload;
  orderChatId: string | null;
  isKycError: boolean;
}

const initialState: UserState = {
  user: null,
  token: null,
  loggedIn: false,
  loading: false,
  firebaseToken: null,
  selectedCoin: null,
  selectedCurrency: null,
  p2pFormStep: 1,
  activePair: null,
  totalPair: null,
  activeCoin: {},
  activeWithdrawCoin: null,
  p2pAddPayload: {
    coin: null,
    type: "BUY",
    fiatCurrency: null,
    price: null,
    minLimit: null,
    maxLimit: null,
    paymentMethods: [],
    paymentTimeLimit: 10,
    amount: null,
    remarks: null,
  },
  P2PorderPayload: {
    type: "",
    offerId: null,
    totalAmountCoin: null,
    totalPaymentInFait: null,
    paymentMethods: null,
    paymentTimeLimitMinutes: null,
  },
  orderChatId: null,
  isKycError: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.loggedIn = action.payload;
    },
    setFirebaseToken: (state, action: PayloadAction<string>) => {
      state.firebaseToken = action.payload;
    },
    setSelectedCoin: (state, action: PayloadAction<any>) => {
      state.selectedCoin = action.payload;
    },
    setSelectedCurrency: (state, action: PayloadAction<any>) => {
      state.selectedCurrency = action.payload;
    },
    setP2PPayload: (state, action: PayloadAction<P2PAddPayload>) => {
      state.p2pAddPayload = action.payload;
    },
    removeP2PPayload: (state, action: PayloadAction<any>) => {
      state.selectedCurrency = action.payload;
    },
    setP2PFromStep: (state, action: PayloadAction<number>) => {
      state.p2pFormStep = action.payload;
    },
    setP2POrder: (state, action: PayloadAction<P2POrderPayload>) => {
      state.P2PorderPayload = action.payload;
    },
    removeP2POrder: (state, action: PayloadAction<P2POrderPayload | null>) => {
      state.P2PorderPayload = action.payload || {} as P2POrderPayload;
    },
    setActivePair: (state, action: PayloadAction<any>) => {
      state.activePair = action.payload;
    },
    setTradingPair: (state, action: PayloadAction<any>) => {
      state.totalPair = action.payload;
    },
    setActiveCoin: (state, action: PayloadAction<any>) => {
      state.activeCoin = action.payload;
    },
    setActiveWithdrawCoin: (state, action: PayloadAction<any>) => {
      state.activeWithdrawCoin = action.payload;
    },
    addChatId: (state, action: PayloadAction<string>) => {
      state.orderChatId = action.payload;
    },
    removeChatId: (state, action: PayloadAction<null>) => {
      state.orderChatId = action.payload;
    },
    setKycStatus: (state, action: PayloadAction<boolean>) => {
      state.isKycError = action.payload;
    },
    logOut: (state) => {
      return initialState;
    },
  },
});

// Export actions
export const {
  setUser,
  setToken,
  setLoading,
  setLoggedIn,
  setFirebaseToken,
  setSelectedCoin,
  setSelectedCurrency,
  setP2PPayload,
  removeP2PPayload,
  setP2PFromStep,
  setP2POrder,
  removeP2POrder,
  setActivePair,
  setTradingPair,
  setActiveCoin,
  setActiveWithdrawCoin,
  addChatId,
  removeChatId,
  setKycStatus,
  logOut,
} = userSlice.actions;

// Export reducer
export default userSlice.reducer; 